/* Best-guess mapping of the activityFeed `reason` enum to a short header
   label. The pasted backend notes describing the exact enum values were
   garbled in transit — confirm these against the live schema and adjust.
   Anything unrecognized (including future reasons the backend adds) falls
   through to null — the caller just omits the suffix rather than showing
   filler text next to the username. */
export const ACTIVITY_FEED_REASON_LABELS: Record<string, string> = {
  OWN_RECENT_CLIP: "You posted a clip",
  FOLLOWED_CREATOR_CLIP: "posted a clip",
  UPCOMING_COMPETITION: "Upcoming competition",
  COMPLETED_COMPETITION: "Competition ended",
};

export const getReasonLabel = (reason: string): string | null =>
  ACTIVITY_FEED_REASON_LABELS[reason] ?? null;
